"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplianceTimeFrame = void 0;
var ComplianceTimeFrame;
(function (ComplianceTimeFrame) {
    ComplianceTimeFrame["MONTHLY"] = "monthly";
    ComplianceTimeFrame["QUARTERLY"] = "quarterly";
})(ComplianceTimeFrame || (exports.ComplianceTimeFrame = ComplianceTimeFrame = {}));
//# sourceMappingURL=BaseComplianceModels.js.map